import { createSelector } from 'reselect'
import currentUserRolesSelector from 'selectors/currentUserRoles'

export const getCurrentUserId = (state, props) => state.kanbo.currentUser.id

export default createSelector(
  [
    currentUserRolesSelector,
    getCurrentUserId,
  ],
  (
    currentUserRoles,
    currentUserId,
  ) => ({
    currentUserRoles,

    currentUserId,
  })
)
